import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Text from 'components/base/Text';
import styled from 'styled-components';
import withSetting from './SettingsHOC';

const StyledRadio = styled.div`
  margin-top: 0.5rem;
  width: 86.4rem;
  ${({ disabled }) => (disabled ? 'pointer-events:none;' : '')};
`;
const REPORTED_RELEASE_RADIO_VALUE = 'reported';
const createRadioButton = (
  radioOption,
  selectedRadio,
  handleRadioChange,
  handleValueChange,
  textValue = '',
  disabled
) => {
  const isTextField = radioOption.input === 'isArray';

  return (
    <FormControlLabel
      key={radioOption.radio_value}
      className={'topAligned'}
      value={
        selectedRadio === REPORTED_RELEASE_RADIO_VALUE
          ? undefined
          : radioOption.radio_value
      }
      control={
        <Radio
          color={disabled ? 'disabled' : 'primary'}
          checked={
            radioOption.radio_value === REPORTED_RELEASE_RADIO_VALUE
              ? true
              : undefined
          }
        />
      }
      onChange={disabled ? _.noop : handleRadioChange}
      label={
        <StyledRadio
          disabled={disabled}
          isTextField={isTextField}
          id='radio-options'
        >
          <Text
            lineHeight={1.7}
            size='large'
            color={disabled ? 'osloGray' : 'darkGray'}
            weight='bold'
            dangerouslySetInnerHTML={{ __html: radioOption.label }}
          />
          <Text
            lineHeight={1.7}
            size='large'
            color={disabled ? 'osloGray' : 'darkGray'}
            dangerouslySetInnerHTML={{ __html: radioOption.subtext }}
          />
          {isTextField && (
            <TextField
              inputProps={{ style: { fontSize: 15 } }}
              variant='outlined'
              onChange={handleValueChange}
              value={textValue}
              placeholder={radioOption.hint}
              disabled={selectedRadio !== radioOption.radio_value}
              focused={selectedRadio === radioOption.radio_value}
            />
          )}
        </StyledRadio>
      }
    />
  );
};

const CustomJsonArea = props => {
  const {
    onChange,
    value,
    customOptions,
    wasReset,
    setWasReset,
    isReportedRelease,
    disabled = false
  } = props;

  // Calling hooks inside of if statement is not permitted
  //if (customOptions.format === 'radio_button'){
  const [radioStates, setRadioStates] = useState({
    [value.key]: value.regex_pattern
  });
  useEffect(() => {
    if (wasReset) {
      setRadioStates({ [value.key]: value.regex_pattern });
      setWasReset(false);
    }
  }, []);

  const handleRadioChange = e => {
    const radioValue = e.target.value;
    /* istanbul ignore next */
    const hasInputValues = _.every(
      customOptions.options.map(option => option.input)
    );

    onChange({
      ...value,
      key: radioValue,
      ...(hasInputValues ? { regex_pattern: radioStates[radioValue] } : {})
    });
  };

  const handleTextValueChange = e => {
    setRadioStates({
      ...radioStates,
      [value.key]: e.target.value
    });

    onChange({
      ...value,
      regex_pattern: e.target.value
    });
  };
  return (
    <FormControl component='fieldset' disabled={disabled}>
      <RadioGroup row name='releaseStrategy' value={value.key}>
        {_.map(customOptions.options, radioOption =>
          createRadioButton(
            radioOption,
            isReportedRelease ? REPORTED_RELEASE_RADIO_VALUE : value.key,
            handleRadioChange,
            handleTextValueChange,
            radioStates[radioOption.radio_value],
            isReportedRelease
          )
        )}
        {isReportedRelease &&
          createRadioButton(
            {
              label: 'API Integration',
              subtext:
                'Releases and custom cycle time stages reported via API integration',
              radio_value: REPORTED_RELEASE_RADIO_VALUE
            },
            REPORTED_RELEASE_RADIO_VALUE,
            handleRadioChange,
            _.noop,
            '',
            true
          )}
      </RadioGroup>
    </FormControl>
  );
};

export default withSetting(CustomJsonArea);
